export const FRONTEND_API_ENDPOINTS = {
  // Authentication Endpoints
  REGISTER: "/user/register",
  LOGIN: "/user/login",
  LOGOUT: "/user/logout",
  AUTH: "/user/auth",

  // Home Page Endpoints
  PAGE: (slugs: string) => `/page/${slugs}`,
  /** Query: `university_id` (required), `limit` (max 50), `offset`, optional `category_id`. */
  BLOG_POSTS_PUBLIC: "/page/blog-posts",
  COURSE_PAGE: (courseName: string) => `/page/program/${courseName}`,
  AUXILIARY_PAGE: (slug: string) => `/auxiliary/${slug}`,
  PROGRAM_AUXILIARY_PAGE: (programName: string, slug: string) =>
    `/auxiliary/program/${programName}/${slug}`,
  SPECIALISATION_AUXILIARY_PAGE: (programName: string, slug: string) =>
    `/auxiliary/specialisation/${programName}/${slug}`,
  LANDING_PAGE: (slug: string) => `/page/landing/${slug}`,
  FOOTER_LINKS: (slug: string) => `/footer/${slug}`,
  BASIC_FOOTER_DETAILS: (universityId: number) =>
    `/university/footer/${universityId}`,
  PAGE_ROUTES: (noOfSlugs: number) => `/page/routes/${noOfSlugs}`,

  // Lead Management
  CREATE_LEAD: "/leads",
  GET_LEAD_BY_PHONE_AND_EMAIL: (phone: string, email: string) =>
    `/leads/getLeadByPhoneAndEmail?mobile=${phone}&email=${email || ""}`,
  VERIFY_OTP: "/leads/verify",
  SEND_OTP_MOBILE: "/leads/send-otp-mobile",
  SUBMIT: "/leads/submit",
  UPDATE_LEAD: "/leads/update",
  UPDATE_LEAD_PROGRAMME: "/leads/update-lead-programme",
  RESEND_OTP: "/leads/resendOtp",
  /** Lead drop variant 3 — create in DB only (no OTP, no ERP/LSQ). */
  CREATE_LEAD_DIRECT: "/leads/direct",
  /** Lead drop variant 4 — OTP verify then CRM push (ERP always; LSQ multi-tenant microsite only). */
  VERIFY_LEAD_DROP4: "/leads/verify-drop4",
  /** Lead drop variant 4 — no-OTP CRM push (ERP always; LSQ multi-tenant microsite only). */
  SYNC_LEAD_DROP4: "/leads/sync-drop4",
  /** Non-verified record-only capture / autosave (additive; does not change form flow) */
  CAPTURE_LEAD: "/leads/capture",
  LMS_SIGNUP: "/leads/lms-signup",
  /** Public grievance/contact form submission (multipart, emails via Resend). */
  GRIEVANCE_SUBMIT: "/grievance-form/submit",
  /** Multi-step intake variant 6 only — do not use for legacy lead forms */
  INTAKE_VERIFY_OTP: "/leads/intake/verify-otp",
  INTAKE_PRIMARY: "/leads/intake/primary",
  INTAKE_SECONDARY: "/leads/intake/secondary",
  /** Public — Indian states / cities for segmented intake step 2 */
  INDIA_GEO_STATES: "/india-geo/states",
  INDIA_GEO_CITIES: (state: string) => `/india-geo/cities?state=${encodeURIComponent(state)}`,
  REVISIT_ERP: "/erp/revisit",
};
